import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ViewModeService } from '@services/view-mode.service';

import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { Logger } from '@utils/logger';

/**
 * Logger
 */
const logger = Logger.getLogger('SectionAnchorComponent');

/**
 * FT Section Anchor component
 *
 * Can be placed anywhere on a page to anchor content.
 *
 * Selector: `SectionAnchorComponent`
 *
 * Exported as: `SectionAnchorComponent`
 */
@Component({
  selector: 'SectionAnchorComponent',
  template: '<div [id]="id">{{isEditMode? "#" + id : ""}}</div>',
})
export class SectionAnchorComponent
  extends AbstractBaseComponent
  implements OnInit, OnChanges {
  /**
   * Constructor
   */
  constructor(private viewModeService: ViewModeService) {
    super();
    this.isEditMode = this.viewModeService.isEditMode();
  }

  /**
   * Angular init hook
   */
  ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Get Section Id
   */
  get id(): string {
    return this.component.getParameters()?.id;
  }
}
